<template>
	<ActivityBadgeLayout class="order-change-activity-badge">
		<FontAwesomeIcon :icon="[ `far`, `arrow-up-arrow-down` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import ActivityBadgeLayout from "./ActivityBadgeLayout";
export default {
	name: "OrderChangeActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color1-500;
$badgeBackgroundColor: $color1-100;

.order-change-activity-badge {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}
</style>
